@if (mode$|async; as mode) {
  <div>
    @if (mode === 'Edit') {
      <app-add-button
        id="add-team-member"
        class="mb-3"
      (appThrottledClick)="openModal()"></app-add-button>
    }
    @if (teamMembers$ | async; as teamMembers) {
      @if (teamMembers.length > 0) {
        <vwui-table class="team-members-list" [standalone]="true">
          <vwui-table-row>
            <vwui-table-header>Naam</vwui-table-header>
            <vwui-table-header>Rol</vwui-table-header>
            @if (mode === 'Edit') {
              <vwui-table-header></vwui-table-header>
            }
          </vwui-table-row>
          @for (member of teamMembers; track member) {
            <vwui-table-row>
              <vwui-table-column class="break-word">
                <div class="inline-flex items-center">
                  <vwui-icon class="vwui-icon-sm text-primary mr-3 shrink-0" iconName="vwui-user"></vwui-icon>
                  <app-copy-to-clipboard [value]="member.name">{{member.name}}</app-copy-to-clipboard>
                </div>
              </vwui-table-column>
              <vwui-table-column class="break-word">
                <app-copy-to-clipboard value="{{member.name}} ({{member.role | teamMemberRoleTranslate}})">{{member.role | teamMemberRoleTranslate}}</app-copy-to-clipboard>
              </vwui-table-column>
              @if (mode === 'Edit' && !member.readonly) {
                <vwui-table-column>
                  <div class="inline-flex w-full items-center justify-end">
                    <vwui-btn-icon id="edit-{{member.id}}" icon="vwui-edit" (click)="openModal(member)"></vwui-btn-icon>
                    <vwui-btn-icon id="delete-{{member.id}}" icon="vwui-trash" (click)="deleteMember(member)"></vwui-btn-icon>
                  </div>
                </vwui-table-column>
              }
            </vwui-table-row>
          }
        </vwui-table>
      } @else {
        <vwui-empty-state
          messageTitle="Geen teamleden"
        message="Er zijn nog geen teamleden toegevoegd"></vwui-empty-state>
      }
    }
  </div>
}
